export const SUBMIT_COMPANY_AUTH_REP_FAILURE = 'SUBMIT_COMPANY_AUTH_REP_FAILURE';
export const SUBMIT_COMPANY_AUTH_REP_REQUEST = 'SUBMIT_COMPANY_AUTH_REP_REQUEST';
export const SUBMIT_COMPANY_AUTH_REP_SUCCESS = 'SUBMIT_COMPANY_AUTH_REP_SUCCESS';
